<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">审核</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div>
    <div class="infoma ub">
      <div class="photo-black">
        <img :src="info.photo" class="photo" />
        <span class="photo-tag ub ub-pc ub-ac">{{info.play_level}}</span>
      </div>
      <div class="ub ub-ver ub-f1">
        <div class="ub">
          <div class="ub ub-pc">
            <span class="nick2">{{info.nick}}</span>
            <img v-if="info.sex=='女生'" src="../../assets/img/女.png" class="sex-img" />
            <img v-if="info.sex=='男生'" src="../../assets/img/男.png" class="sex-img" />
          </div>
          <div class="ub ub-f1 ub-ae">
            <div class="tip ub ub-pc"  v-for="(s, index) in info.serve" :key="index">
              <div class="d1"></div>
              <span class="sp2">{{s}}</span>
            </div>
          </div>
        </div>

        <div>
          <span class="tag" v-for="(t, index) in info.tags" :key="index">{{t}}</span>
        </div>
        <div>
          <div class="voice ub ub-pc">
           <img src="../../assets/img/声音.png" class="voice-img" />
           <span>播放</span>
         </div>
        </div>
      </div>
    </div>

    <div class="ub" style="padding:0 .8em">
            <div class="menu-line"></div>
    </div>
</div>

<div class="btn-block2">
    <span>基本资料</span>
    <span>上传录音</span>
    <span>上传图片</span>
    <span>选择标签</span>
    <span>修改签名</span>
</div>

  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      info: {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          play_level:"镇店",
          nick: "鸣人",
          sex: "女生",
          serve: ["在线","语音","陪玩"],
          tags:["甜甜咸咸","乖巧","爱狗狗","哄睡","小话唠",],
          voice:""
        },
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
  },
};
</script>

<style scoped>
.top-img{
  padding: .8em;
  background-color: #FFF;
}
.top-img img{
  width: 100%;
  border-radius: .5em;
}
.tit{
  background-color: #FFF;
}
.tit div {
  height: 3.3em;
  font-weight: bold;
  color: #333;
  font-size: 0.95em;
  width: 33.3%;
}
.d1 {
  border-bottom: 1px solid #f4f5f6;
}
.d2 {
  border-left: 1px solid #f4f5f6;
  border-right: 1px solid #f4f5f6;
  border-bottom: 1px solid #f4f5f6;
}
.d3 {
  border-bottom: 1px solid #f4f5f6;
}
.infoma {
  padding: 1.3em .8em;
  background-color: #FFF;
}
.infoma:hover{
  background-color: #f2f3f5;
}

.photo-black{
  width: 5em;
  height: 5em;
  margin-right: .5em;
  position: relative;
}
.photo-tag{
  position: absolute;
  background-color: #f3b4cf;
  font-size: .8em;
  border-radius: 1em;
  color: #fff;
  padding: .1em .2em;
  width: 3em;
  bottom: .5em;
  right: .2em;
}
.photo {
  width: 5em;
  height: 5em;
  border-radius: 50%;
  
}
.nick2 {
  font-weight: bold;
  font-size: 0.85em;
   margin-left: .3em;
}
.sex-img {
  width: 1.2em;
}
.tip {
  margin-right: 0.5em;
}
.tip .d1 {
  width: 0.5em;
  height: 0.5em;
  background-color: #5ea3ef;
  border-radius: 50%;
  margin-right: 0.2em;
}
.tip .sp2{
  font-size: 0.85em;
}
.tag{
  display: inline-block;
  padding: .2em .5em;
  border:1px solid #5ea3ef;
  border-radius: 1em;
  font-size: .8em;
  color: #5ea3ef;
  margin: .3em .3em;
}
.voice{
  background-color: #5ea3ef;
  margin-left:.3em;
  font-size: .8em;
  width: 6em;
  color: #fff;
  padding: .5em .5em;
  border-radius: 2em;
  margin-top: .5em;
}
.voice-img{
width: 1.5em;
height: 1.5em;
margin-left: .5em;
}
select{
  background: transparent;
  border: none;
  font-size: 1em;
  color: #e92162;
}
.btn-block2{
    background-color: #fff;
    padding: .8em 0;
}
.btn-block2 span{
    font-size: .95em;
    display: inline-block;
    border: 1px solid #e92162;
    padding: .3em .5em;
    margin:.4em .4em;
    border-radius: .3em;
    color: #e92162;
}
</style>